/** Reset password data. */
export class ResetPasswordData {
  constructor(data) {
    this.newPassword = data.newPassword;
    this.confirmNewPassword = data.confirmNewPassword;
  }
}
